export default "__VITE_ASSET__DxpFYnvC__"